import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStatefulApi } from 'src/services';
import { HMITemplate, deleteHmiConfiguration } from 'src/hmi';

export interface HmiConfigurationDeleteModalProps {
  template: HMITemplate;
  solutionId: string;
  siteId: string;
  twinId: string;
  open: boolean;
  onClose: ModalCloseHandler;
}

/** Confirm-then-delete dialog for the twin's HMI template, mirroring the other Asset Hierarchy tabs' delete modals. */
function HmiConfigurationDeleteModal({
  template,
  solutionId,
  siteId,
  twinId,
  open,
  onClose,
}: HmiConfigurationDeleteModalProps) {
  const { showAlert } = useAlert();

  const [handleDelete, loading] = useStatefulApi(
    () => deleteHmiConfiguration(solutionId, siteId, twinId, template.id),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'HMI template deleted',
        text: `"${template.name}" has been deleted successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
    },
    () => {
      showAlert({
        type: AlertType.Error,
        title: 'Failed to delete HMI template',
        text: 'An error occurred while deleting the HMI template. Please try again.',
      });
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Delete HMI Template"
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      cancelBtnText="No"
      confirmBtnText="Yes"
      maxWidth="sm"
      fullWidth
    >
      Are you sure you want to delete the HMI template configured for this asset?
      <br />
      <b>{template.name}</b>
    </ModalDialog>
  );
}

export default HmiConfigurationDeleteModal;
